import Modal from '@/components/Modal';
import React, { useEffect } from 'react';
import { CustomModalContent, CustomModalHeader } from './styles';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  redirect_uri: string;
};

const ExecucaoProtocoloEnterpriseModal: React.FC<Props> = ({
  isOpen,
  onClose,
  redirect_uri,
}) => {
  useEffect(() => {
    const listener = (event: MessageEvent) => {
      const {
        data: { type },
      } = event;
      if (type === 'closeMedflowApp') {
        onClose();
      }
    };

    if (redirect_uri) {
      window.addEventListener('message', listener, false);
    } else {
      window.removeEventListener('message', listener);
    }
  }, [onClose, redirect_uri]);

  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onAfterClose={onClose}
      shouldCloseOnOverlayClick={false}
      style={{
        content: { width: '100%', maxWidth: '1024px', height: '700px' },
      }}
    >
      <CustomModalContent>
        <CustomModalHeader closeButton onClick={onClose} />
        <iframe
          src={redirect_uri}
          title="Execução de Protocolo Enterprise"
          allow="clipboard-read; clipboard-write"
          style={{
            flex: '1 1',
          }}
        />
      </CustomModalContent>
    </Modal>
  );
};

export default ExecucaoProtocoloEnterpriseModal;
